import { render, staticRenderFns } from "./AdminView.vue?vue&type=template&id=abd8ff28&scoped=true&"
import script from "./AdminView.vue?vue&type=script&lang=ts&"
export * from "./AdminView.vue?vue&type=script&lang=ts&"
import style0 from "./AdminView.vue?vue&type=style&index=0&id=abd8ff28&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd8ff28",
  null
  
)

export default component.exports